<script>
  import Alert from '@leaflink/stash/Alert.vue';
  import Button from '@leaflink/stash/Button.vue';
  import Icon from '@leaflink/stash/Icon.vue';
  import { storeToRefs } from 'pinia';

  import { ROUTE_NAMES } from '@/constants';
  import { useUserStore } from '@/piniaStores/user/user.store';

  export default {
    name: 'LinkABankButton',

    components: {
      Alert,
      Button,
      Icon,
    },

    emits: ['submit', 'error'],

    setup() {
      const { userActiveCompany } = storeToRefs(useUserStore());

      return {
        activeCompany: userActiveCompany,
      };
    },

    data() {
      return {
        error: '',
        isInitiating: false,
      };
    },

    methods: {
      onError() {
        this.error = this.$t('termsAndConditions.linkABankCta.initiationError');
        this.$emit('error');
      },

      onSubmit() {
        this.isInitiating = true;

        try {
          // go to payments and pass necessary params to initiate plaid bank linking process
          const query = {
            company_type: this.activeCompany.seller ? 'seller' : 'buyer',
            company_id: this.activeCompany.id,
            open_bank_linking: true,
          };
          const route = this.$router.resolve({ name: ROUTE_NAMES.PAYMENTS_ACCOUNT_SETTINGS, query });
          const target = this.$route.name === ROUTE_NAMES.CART ? '_blank' : '_self';

          // redirect the user to payments via /accounts/login to ensure their MP session is re-created, ensuring their
          // user meta is up to date and portal access meta is up to date!
          window.open(`/accounts/login?next=${encodeURIComponent(route.href)}`, target);
          this.$emit('submit');
        } catch (error) {
          this.onError();
          throw error;
        } finally {
          this.isInitiating = false;
        }
      },
    },
  };
</script>

<template>
  <div>
    <Alert v-if="error" permanent severity="error">
      {{ error }}
    </Alert>
    <Button class="tw-w-full tw-mb-3" :disabled="isInitiating || !!error" @click="onSubmit">
      {{ $t('termsAndConditions.linkABankCta.submitButton') }}
      <Icon v-if="isInitiating" name="refresh" class="fx-spin tw-ml-3" />
    </Button>
  </div>
</template>
